import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Long2qws0ah9gnpki as Long,
  Unit_instanceat14thlj150z as Unit_instance,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  protoOf180f3jzyo7rfj as protoOf,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration7gy6v749ektt as toDuration,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  ArrayList3it5z8td81qkl as ArrayList,
  HashSet2dzve9y63nf0v as HashSet,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  get_lastIndexx0qsydpfv3mu as get_lastIndex,
  compareTo3ankvs086tmwq as compareTo,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Comparable198qfk8pnblz0 as Comparable,
  numberToDouble210hrknaofnhf as numberToDouble,
  sort15ai02l4kxbfa as sort,
  coerceAtLeast3jlgfquiyquc9 as coerceAtLeast,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  printStackTrace18lnx7a39cni as printStackTrace,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  toDuration28gf6ughsr3vf as toDuration_0,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  CancellationException3b36o9qz53rgr as CancellationException,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  createFailure8paxfkfa5dc7 as createFailure,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  Key_instance3trehy4y6zgij as Key_instance,
  getxe4seun860fg as get_0,
  minusKey2uxs00uz5ceqp as minusKey_0,
  releaseInterceptedContinuation17jnf0xkuoovi as releaseInterceptedContinuation,
  ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor,
  Result__exceptionOrNull_impl_p6xea93g9kuxe56cw2k as Result__exceptionOrNull_impl_p6xea9,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqgbxrwpgk5sesh as _Result___get_value__impl__bjfvqg,
  Continuation1aa2oekvx7jm7 as Continuation,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  println2shhhgwwt4c61 as println,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
} from './kotlin-kotlin-stdlib.mjs';
import {
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
} from './kotlinx-atomicfu.mjs';
import {
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  compareTo2tbidk88xyn1w as compareTo_0,
  FastDuration__minus_impl_evs237bt7zqxxnwet as FastDuration__minus_impl_evs237,
  FastDuration__compareTo_impl_4fhnj73optjj2wg605h as FastDuration__compareTo_impl_4fhnj7,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7_0,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  get_fast37cu8s8qwnuyi as get_fast,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237_0,
  FastDuration3d3pupg2e5ora as FastDuration,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher,
  Delay9umexudtwyie as Delay,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  launch1c91vkjzdi9sd as launch,
  delay1blitpytzu6gr as delay,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope_0,
  invokeOnTimeout3llts2igdsa63 as invokeOnTimeout,
} from './kotlinx-coroutines-core.mjs';
import { FastArrayListw5fr1wlp4slq as FastArrayList } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class NonRecursiveLock {
  constructor() {
    this.x35_1 = new Object();
  }
}
class BaseLockWithNotifyAndWait {}
function notify$default(unit, $super) {
  unit = unit === VOID ? Unit_instance : unit;
  var tmp;
  if ($super === VOID) {
    this.f36(unit);
    tmp = Unit_instance;
  } else {
    var tmp_0 = $super.f36;
    tmp = tmp_0.call(this, Unit_instance);
  }
  return tmp;
}
class LockImpl {
  constructor() {
    this.y35_1 = atomic$boolean$1(false);
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.z35_1 = get_atomicfu$reentrantLock();
    this.a36_1 = atomic$long$1(new Long(0, 0));
    this.b36_1 = atomic$int$1(0);
  }
  c36() {
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.lock' call
    this.z35_1;
    this.b36_1.atomicfu$incrementAndGet();
    this.a36_1.kotlinx$atomicfu$value = _NativeThread___get_id__impl__jog4wy(Companion_instance_1.d36());
  }
  e36() {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.b36_1.kotlinx$atomicfu$value > 0)) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.unlock.<anonymous>' call
      var message = 'Must unlock inside a synchronization block';
      throw IllegalStateException.h5(toString(message));
    }
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.unlock' call
    this.z35_1;
    this.b36_1.atomicfu$decrementAndGet();
  }
  f36(unit) {
    if (!get_isSupported(Companion_instance_3))
      throw UnsupportedOperationException.s8();
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.b36_1.kotlinx$atomicfu$value > 0)) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.notify.<anonymous>' call
      var message = 'Must notify inside a synchronization block';
      throw IllegalStateException.h5(toString(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.a36_1.kotlinx$atomicfu$value.equals(_NativeThread___get_id__impl__jog4wy(Companion_instance_1.d36()))) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.notify.<anonymous>' call
      var message_0 = 'Must lock the notify thread';
      throw IllegalStateException.h5(toString(message_0));
    }
    this.y35_1.kotlinx$atomicfu$value = true;
  }
  h36(time) {
    if (!get_isSupported(Companion_instance_3))
      throw UnsupportedOperationException.s8();
    var lockCount = this.b36_1.kotlinx$atomicfu$value;
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(lockCount > 0)) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.wait.<anonymous>' call
      var message = 'Must wait inside a synchronization block';
      throw IllegalStateException.h5(toString(message));
    }
    var start = Monotonic_instance.fk();
    this.y35_1.kotlinx$atomicfu$value = false;
    // Inline function 'kotlin.repeat' call
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < lockCount)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.concurrent.lock.LockImpl.wait.<anonymous>' call
        this.e36();
      }
       while (inductionVariable < lockCount);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.b36_1.kotlinx$atomicfu$value === 0)) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.wait.<anonymous>' call
      var message_0 = 'Must unlock all locks';
      throw IllegalStateException.h5(toString(message_0));
    }
    try {
      // Inline function 'korlibs.concurrent.thread.sleepWhile' call
      var stepTime = get_fastMilliseconds(1.0);
      $l$loop: while (true) {
        // Inline function 'korlibs.concurrent.lock.LockImpl.wait.<anonymous>' call
        if (!(!this.y35_1.kotlinx$atomicfu$value && compareTo_0(ValueTimeMark__elapsedNow_impl_eonqvs(start), time) < 0)) {
          break $l$loop;
        }
        sleep(Companion_instance_1, stepTime, false);
      }
    }finally {
      // Inline function 'kotlin.repeat' call
      // Inline function 'kotlin.contracts.contract' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < lockCount)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.concurrent.lock.LockImpl.wait.<anonymous>' call
          this.c36();
        }
         while (inductionVariable_0 < lockCount);
    }
  }
}
class Companion {
  constructor() {
    Companion_instance_0 = this;
    this.j36_1 = _NativeThreadPriority___init__impl__qecm6c(0.0);
    this.k36_1 = _NativeThreadPriority___init__impl__qecm6c(0.25);
    this.l36_1 = _NativeThreadPriority___init__impl__qecm6c(0.5);
    this.m36_1 = _NativeThreadPriority___init__impl__qecm6c(0.75);
    this.n36_1 = _NativeThreadPriority___init__impl__qecm6c(0.9);
    this.o36_1 = _NativeThreadPriority___init__impl__qecm6c(1.0);
  }
}
class Companion_0 {
  i36() {
    return get_NativeThreadThread_isSupported();
  }
  d36() {
    return _NativeThread___init__impl__p2udts(NativeThreadThread_current());
  }
  p36(name, isDaemon, priority, code) {
    return _NativeThread___init__impl__p2udts(NativeThreadThread_start(name, isDaemon, priority, code));
  }
  q36(time) {
    return NativeThreadThread_sleep(time);
  }
}
class FixedPoolNativeThreadDispatcher extends CoroutineDispatcher {
  static z36(numThreads, name, priority, isDaemon, preciseTimings) {
    name = name === VOID ? 'FixedPoolNativeThreadDispatcher' : name;
    priority = priority === VOID ? Companion_getInstance_0().l36_1 : priority;
    isDaemon = isDaemon === VOID ? true : isDaemon;
    preciseTimings = preciseTimings === VOID ? false : preciseTimings;
    var $this = this.n2l();
    $this.s36_1 = numThreads;
    $this.t36_1 = name;
    $this.u36_1 = priority;
    $this.v36_1 = isDaemon;
    $this.w36_1 = preciseTimings;
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!($this.s36_1 >= 1)) {
      // Inline function 'korlibs.concurrent.thread.FixedPoolNativeThreadDispatcher.<anonymous>' call
      var message = 'numThreads should be >= 1';
      throw IllegalStateException.h5(toString(message));
    }
    var tmp = $this;
    var tmp_0 = 0;
    var tmp_1 = $this.s36_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = NativeThreadDispatcher.n37($this.t36_1 + '-' + tmp_3, $this.u36_1, $this.v36_1, $this.w36_1);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.x36_1 = tmp_2;
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.x36_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.concurrent.thread.FixedPoolNativeThreadDispatcher.threadIds.<anonymous>' call
      var tmp$ret$3 = _NativeThread___get_id__impl__jog4wy(item.l37_1);
      destination.h(tmp$ret$3);
    }
    tmp_4.y36_1 = HashSet.wa(destination);
    return $this;
  }
  p6() {
    var indexedObject = this.x36_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var dispatcher = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      dispatcher.p6();
    }
  }
  o2l(context) {
    return !this.y36_1.z2(_NativeThread___get_id__impl__jog4wy(Companion_instance_1.d36()));
  }
  p2l(context, block) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      var this_0 = this.x36_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0)
        throw NoSuchElementException.x6();
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block;
      }
      // Inline function 'korlibs.concurrent.thread.FixedPoolNativeThreadDispatcher.dispatch.<anonymous>' call
      var minValue = minElem.o37();
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.concurrent.thread.FixedPoolNativeThreadDispatcher.dispatch.<anonymous>' call
          var v = e.o37();
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    tmp$ret$1.p2l(context, block);
  }
  q2l(context, block) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      var this_0 = this.x36_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0)
        throw NoSuchElementException.x6();
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block;
      }
      // Inline function 'korlibs.concurrent.thread.FixedPoolNativeThreadDispatcher.dispatchYield.<anonymous>' call
      var minValue = minElem.o37();
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.concurrent.thread.FixedPoolNativeThreadDispatcher.dispatchYield.<anonymous>' call
          var v = e.o37();
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    tmp$ret$1.q2l(context, block);
  }
  b2m(timeMillis, continuation) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      var this_0 = this.x36_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0)
        throw NoSuchElementException.x6();
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block;
      }
      // Inline function 'korlibs.concurrent.thread.FixedPoolNativeThreadDispatcher.scheduleResumeAfterDelay.<anonymous>' call
      var minValue = minElem.p37();
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.concurrent.thread.FixedPoolNativeThreadDispatcher.scheduleResumeAfterDelay.<anonymous>' call
          var v = e.p37();
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    tmp$ret$1.b2m(timeMillis, continuation);
  }
  c2m(timeMillis, block, context) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      var this_0 = this.x36_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0)
        throw NoSuchElementException.x6();
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block;
      }
      // Inline function 'korlibs.concurrent.thread.FixedPoolNativeThreadDispatcher.invokeOnTimeout.<anonymous>' call
      var minValue = minElem.p37();
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.concurrent.thread.FixedPoolNativeThreadDispatcher.invokeOnTimeout.<anonymous>' call
          var v = e.p37();
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return tmp$ret$1.c2m(timeMillis, block, context);
  }
}
class TimedTask {
  constructor(dispatcher, time, task, block) {
    this.q37_1 = dispatcher;
    this.r37_1 = time;
    this.s37_1 = task;
    this.t37_1 = block;
  }
  u37(other) {
    return FastDuration__compareTo_impl_4fhnj7_0(this.r37_1, this.r37_1);
  }
  d(other) {
    return this.u37(other instanceof TimedTask ? other : THROW_CCE());
  }
  k2i() {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.q37_1.h37_1;
    // Inline function 'korlibs.concurrent.thread.TimedTask.dispose.<anonymous>' call
    this.q37_1.i37_1.g3(this);
  }
}
class NativeThreadDispatcher extends CoroutineDispatcher {
  static n37(name, priority, isDaemon, preciseTimings) {
    name = name === VOID ? 'NativeThreadDispatcher' : name;
    priority = priority === VOID ? Companion_getInstance_0().l36_1 : priority;
    isDaemon = isDaemon === VOID ? true : isDaemon;
    preciseTimings = preciseTimings === VOID ? false : preciseTimings;
    var $this = this.n2l();
    $this.b37_1 = name;
    $this.c37_1 = priority;
    $this.d37_1 = isDaemon;
    $this.e37_1 = preciseTimings;
    $this.f37_1 = true;
    $this.g37_1 = new Lock();
    $this.h37_1 = new Object();
    $this.i37_1 = ArrayDeque.ll();
    $this.j37_1 = new Lock();
    $this.k37_1 = ArrayDeque.ll();
    var tmp = $this;
    var tmp4_name = $this.b37_1;
    var tmp5_priority = $this.c37_1;
    var tmp6_isDaemon = $this.d37_1;
    tmp.l37_1 = Companion_instance_1.p36(tmp4_name, tmp6_isDaemon, tmp5_priority, NativeThreadDispatcher$thread$lambda($this));
    $this.m37_1 = Monotonic_instance.fk();
    return $this;
  }
  o37() {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.j37_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.c36();
      try {
        // Inline function 'korlibs.concurrent.thread.NativeThreadDispatcher.<get-numTasks>.<anonymous>' call
        tmp$ret$1 = this.k37_1.hl_1;
        break $l$block;
      }finally {
        this_0.e36();
      }
    }
    return tmp$ret$1;
  }
  p37() {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.h37_1;
    // Inline function 'korlibs.concurrent.thread.NativeThreadDispatcher.<get-numTimedTasks>.<anonymous>' call
    return this.i37_1.hl_1;
  }
  o2l(context) {
    return _NativeThread___get_id__impl__jog4wy(Companion_instance_1.d36()).equals(_NativeThread___get_id__impl__jog4wy(this.l37_1));
  }
  p6() {
    // Inline function 'korlibs.concurrent.lock.notify' call
    var this_0 = this.g37_1;
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.c36();
      try {
        // Inline function 'korlibs.concurrent.lock.notify.<anonymous>' call
        // Inline function 'kotlin.also' call
        this.f37_1 = false;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.concurrent.lock.notify.<anonymous>.<anonymous>' call
        this_0.g36();
        break $l$block;
      }finally {
        this_0.e36();
      }
    }
  }
  p2l(context, block) {
    // Inline function 'korlibs.concurrent.lock.notify' call
    var this_0 = this.g37_1;
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    $l$block_0: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.c36();
      try {
        // Inline function 'korlibs.concurrent.lock.notify.<anonymous>' call
        // Inline function 'kotlin.also' call
        // Inline function 'korlibs.concurrent.thread.NativeThreadDispatcher.dispatch.<anonymous>' call
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var this_1 = this.j37_1;
        $l$block: {
          // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
          this_1.c36();
          try {
            // Inline function 'korlibs.concurrent.thread.NativeThreadDispatcher.dispatch.<anonymous>.<anonymous>' call
            this.k37_1.h(block);
            break $l$block;
          }finally {
            this_1.e36();
          }
        }
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.concurrent.lock.notify.<anonymous>.<anonymous>' call
        this_0.g36();
        break $l$block_0;
      }finally {
        this_0.e36();
      }
    }
  }
  q2l(context, block) {
    super.q2l(context, block);
  }
  b2m(timeMillis, continuation) {
    _sched(this, timeMillis, continuation, null);
  }
  c2m(timeMillis, block, context) {
    return _sched(this, timeMillis, null, block);
  }
}
class onCancel$slambda$slambda {
  constructor($running, $check, $block) {
    this.v37_1 = $running;
    this.w37_1 = $check;
    this.x37_1 = $block;
  }
  f2y($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withContext), $completion);
  }
  le(p1, $completion) {
    return this.f2y((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class onCancel$slambda {
  constructor($running, $check, $block) {
    this.y37_1 = $running;
    this.z37_1 = $check;
    this.a38_1 = $block;
  }
  f2y($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
  }
  le(p1, $completion) {
    return this.f2y((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class _no_name_provided__qut3iv {
  constructor($running) {
    this.b38_1 = $running;
  }
  p6() {
    this.b38_1._v = false;
    return Unit_instance;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_2 = this;
    this.c38_1 = new PreferSyncIo(true);
    this.d38_1 = new PreferSyncIo(false);
  }
  e38(preferSyncIo) {
    return preferSyncIo === true ? this.c38_1 : this.d38_1;
  }
}
class PreferSyncIo {
  constructor(preferSyncIo) {
    Companion_getInstance_2();
    this.f38_1 = preferSyncIo;
  }
  v1() {
    return Companion_getInstance_2();
  }
  toString() {
    return 'PreferSyncIo(preferSyncIo=' + this.f38_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.f38_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreferSyncIo))
      return false;
    var tmp0_other_with_cast = other instanceof PreferSyncIo ? other : THROW_CCE();
    if (!(this.f38_1 === tmp0_other_with_cast.f38_1))
      return false;
    return true;
  }
}
class BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = BaseSignal$_init_$lambda_tuu04y;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    this.l38_1 = onRegister;
    this.m38_1 = FastArrayList.u28();
    this.n38_1 = FastArrayList.u28();
    this.o38_1 = 0;
  }
  v38() {
    return this.m38_1.g1();
  }
  w38() {
    return this.v38() > 0;
  }
  p38(once, handler) {
    this.l38_1();
    var node = new Node(this, once, handler);
    this.m38_1.h(node);
    return node;
  }
}
class Signal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = Signal$_init_$lambda_6vimhp;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  k38(handler) {
    return this.p38(false, handler);
  }
  q38(handler) {
    return this.k38(handler);
  }
  r38(value) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
      if (this.m38_1.j1()) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
      try {
        this.o38_1 = this.o38_1 + 1 | 0;
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_0 = this.m38_1;
        var n = 0;
        var m = 0;
        while (n < this_0.g1()) {
          if (m >= 0 && !(m === n)) {
            this_0.i3(m, this_0.h1(n));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var node = this_0.h1(n);
          var remove = node.s38_1;
          // Inline function 'korlibs.io.async.Signal.invoke.<anonymous>' call
          node.t38_1(value);
          if (remove) {
            m = m - 1 | 0;
          }
          n = n + 1 | 0;
          m = m + 1 | 0;
        }
        while (this_0.g1() > m) {
          this_0.j3(this_0.g1() - 1 | 0);
        }
      }finally {
        this.o38_1 = this.o38_1 - 1 | 0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.n38_1.j1()) {
          // Inline function 'korlibs.io.async.fastIterateRemove' call
          var this_1 = this.n38_1;
          var n_0 = 0;
          var m_0 = 0;
          while (n_0 < this_1.g1()) {
            if (m_0 >= 0 && !(m_0 === n_0)) {
              this_1.i3(m_0, this_1.h1(n_0));
            }
            // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
            var it = this_1.h1(n_0);
            this.m38_1.g3(it);
            if (true) {
              m_0 = m_0 - 1 | 0;
            }
            n_0 = n_0 + 1 | 0;
            m_0 = m_0 + 1 | 0;
          }
          while (this_1.g1() > m_0) {
            this_1.j3(this_1.g1() - 1 | 0);
          }
        }
      }
    }
    return tmp$ret$0;
  }
}
class AsyncSignal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = AsyncSignal$_init_$lambda_rsv6fb;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  b39(value, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, value), $completion);
  }
}
class Node {
  constructor($outer, once, item) {
    this.u38_1 = $outer;
    this.s38_1 = once;
    this.t38_1 = item;
  }
  p6() {
    if (this.u38_1.o38_1 > 0) {
      this.u38_1.n38_1.h(this);
    } else {
      this.u38_1.m38_1.g3(this);
    }
  }
}
class runBlockingNoSuspensions$1$context$1 extends AbstractCoroutineContextElement {
  static f39($suspendCount, $box) {
    if ($box === VOID)
      $box = {};
    $box.e39_1 = $suspendCount;
    var $this = this.jo(Key_instance, $box);
    $this.d39_1 = Key_instance;
    return $this;
  }
  v1() {
    return this.d39_1;
  }
  vd(continuation) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.async.<no name provided>.interceptContinuation.<anonymous>' call
    var _unary__edvuaz = this.e39_1._v;
    this.e39_1._v = _unary__edvuaz + 1 | 0;
    return continuation;
  }
  b2m(timeMillis, continuation) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    continuation.jd(tmp$ret$0);
    return Unit_instance;
  }
}
class runBlockingNoSuspensions$1 {
  constructor($suspendCount, $resultEx, $completed, $rresult) {
    this.h39_1 = $resultEx;
    this.i39_1 = $completed;
    this.j39_1 = $rresult;
    var tmp = this;
    tmp.g39_1 = runBlockingNoSuspensions$1$context$1.f39($suspendCount);
  }
  hd() {
    return this.g39_1;
  }
  k39(result) {
    var exception = Result__exceptionOrNull_impl_p6xea9(result);
    if (!(exception == null)) {
      this.h39_1._v = exception;
      this.i39_1._v = true;
      printStackTrace(exception);
    } else {
      // Inline function 'kotlin.getOrThrow' call
      throwOnFailure(result);
      var tmp = _Result___get_value__impl__bjfvqg(result);
      var tmp0_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        _get_unitInstance__yoa8mq(this);
        var tmp_1 = Unit_instance;
        var tmp_2;
        if (!(Unit_instance == null)) {
          tmp_2 = Unit_instance;
        } else {
          tmp_2 = THROW_CCE();
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var rvalue = tmp_0;
      this.j39_1._v = rvalue;
      this.i39_1._v = true;
    }
  }
  jd(result) {
    return this.k39(result);
  }
}
class Companion_2 {}
class Lock extends LockImpl {}
//endregion
function get_isSupported(_this__u8e3s4) {
  return Companion_instance_1.i36();
}
function _NativeThreadPriority___init__impl__qecm6c(ratio) {
  return ratio;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
function _NativeThread___init__impl__p2udts(native) {
  return native;
}
function _NativeThread___get_native__impl__f44o82($this) {
  return $this;
}
function _NativeThread___get_id__impl__jog4wy($this) {
  return NativeNativeThread_getId(_NativeThread___get_native__impl__f44o82($this));
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function sleep(_this__u8e3s4, time, exact) {
  if (exact) {
    sleepExact(_this__u8e3s4, time);
  } else {
    Companion_instance_1.q36(time);
  }
}
function sleepExact(_this__u8e3s4, time) {
  var start = Monotonic_instance.fk();
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var imprecision = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
  var javaSleep = FastDuration__minus_impl_evs237(time, imprecision);
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$1 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (FastDuration__compareTo_impl_4fhnj7(javaSleep, tmp$ret$1) >= 0) {
    Companion_instance_1.q36(javaSleep);
  }
  // Inline function 'korlibs.concurrent.thread.Companion.spinWhile' call
  $l$loop: while (true) {
    // Inline function 'korlibs.concurrent.thread.sleepExact.<anonymous>' call
    if (!(compareTo_0(ValueTimeMark__elapsedNow_impl_eonqvs(start), time) < 0)) {
      break $l$loop;
    }
  }
}
function _sched($this, timeMillis, continuation, block) {
  var tmp = now($this);
  // Inline function 'korlibs.time.fastMilliseconds' call
  var tmp$ret$0 = get_fastMilliseconds(numberToDouble(timeMillis));
  var task = new TimedTask($this, FastDuration__plus_impl_q1enab(tmp, tmp$ret$0), continuation, block);
  // Inline function 'korlibs.concurrent.lock.notify' call
  var this_0 = $this.g37_1;
  // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
    this_0.c36();
    try {
      // Inline function 'korlibs.concurrent.lock.notify.<anonymous>' call
      // Inline function 'kotlin.also' call
      // Inline function 'kotlinx.atomicfu.locks.synchronized' call
      $this.h37_1;
      var firstTask = $this.i37_1.nl();
      if (firstTask == null || FastDuration__compareTo_impl_4fhnj7_0(task.r37_1, firstTask.r37_1) < 0) {
        $this.i37_1.ol(task);
      } else {
        $this.i37_1.pl(task);
        sort($this.i37_1);
      }
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.concurrent.lock.notify.<anonymous>.<anonymous>' call
      this_0.g36();
      break $l$block;
    }finally {
      this_0.e36();
    }
  }
  return task;
}
function now($this) {
  return get_fast(ValueTimeMark__elapsedNow_impl_eonqvs($this.m37_1));
}
function NativeThreadDispatcher$thread$lambda(this$0) {
  return function () {
    $l$loop: while (this$0.f37_1) {
      try {
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var this_0 = this$0.g37_1;
        $l$block: {
          // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
          this_0.c36();
          try {
            if (this$0.k37_1.j1()) {
              // Inline function 'kotlinx.atomicfu.locks.synchronized' call
              this$0.h37_1;
              // Inline function 'korlibs.concurrent.thread.NativeThreadDispatcher.thread.<anonymous>.<anonymous>.<anonymous>' call
              var firstTask = this$0.i37_1.nl();
              var time = !(firstTask == null) ? FastDuration__minus_impl_evs237_0(firstTask.r37_1, now(this$0)) : get_fastMilliseconds_0(10000);
              this$0.g37_1.h36(coerceAtLeast(new FastDuration(time), new FastDuration(get_fastMilliseconds(0.1))).u35_1);
            }
            break $l$block;
          }finally {
            this_0.e36();
          }
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
        } else {
          throw $p;
        }
      }
      if (!this$0.f37_1)
        break $l$loop;
      try {
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var this_1 = this$0.j37_1;
        var tmp$ret$5;
        $l$block_0: {
          // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
          this_1.c36();
          try {
            // Inline function 'korlibs.concurrent.thread.NativeThreadDispatcher.thread.<anonymous>.<anonymous>' call
            tmp$ret$5 = this$0.k37_1.rl();
            break $l$block_0;
          }finally {
            this_1.e36();
          }
        }
        var task = tmp$ret$5;
        if (task == null)
          null;
        else {
          task.l2k();
        }
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = this$0;
        $l$loop_0: while (true) {
          // Inline function 'kotlinx.atomicfu.locks.synchronized' call
          $this$run.h37_1;
          // Inline function 'korlibs.concurrent.thread.NativeThreadDispatcher.thread.<anonymous>.<anonymous>.<anonymous>' call
          var tryTask = $this$run.i37_1.nl();
          var tmp0_elvis_lhs = !(tryTask == null) && FastDuration__compareTo_impl_4fhnj7_0(now($this$run), tryTask.r37_1) >= 0 ? $this$run.i37_1.ql() : null;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            break $l$loop_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var task_0 = tmp;
          var tmp1_safe_receiver = task_0.s37_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$9 = _Result___init__impl__xyqfz8(Unit_instance);
            tmp1_safe_receiver.jd(tmp$ret$9);
          }
          var tmp2_safe_receiver = task_0.t37_1;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.l2k();
          }
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e_0 = $p;
          printStackTrace(e_0);
        } else {
          throw $p;
        }
      }
    }
    return Unit_instance;
  };
}
function onCancel(_this__u8e3s4, check, block) {
  var tmp;
  if (check === VOID) {
    tmp = onCancel$lambda;
  } else {
    tmp = check;
  }
  check = tmp;
  var running = {_v: true};
  var tmp_0 = CoroutineScope(_this__u8e3s4);
  launch(tmp_0, VOID, VOID, onCancel$slambda_0(running, check, block));
  // Inline function 'kotlin.AutoCloseable' call
  return new _no_name_provided__qut3iv(running);
}
function onCancel$lambda() {
  return true;
}
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  try {
    while ($this.v37_1._v && $this.w37_1()) {
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$0 = toDuration_0(0.1, DurationUnit_SECONDS_getInstance());
      var tmp = delay(tmp$ret$0, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
      if ($this.v37_1._v)
        $this.x37_1(true);
    } else {
      throw $p;
    }
  }
  finally {
    if ($this.v37_1._v)
      $this.x37_1(false);
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = CoroutineName.v2l('onCancel');
  var tmp_0 = withContext(tmp, onCancel$slambda$slambda_0($this.y37_1, $this.z37_1, $this.a38_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function onCancel$slambda$slambda_0($running, $check, $block) {
  var i = new onCancel$slambda$slambda($running, $check, $block);
  var l = function ($this$withContext, $completion) {
    return i.f2y($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function onCancel$slambda_0($running, $check, $block) {
  var i = new onCancel$slambda($running, $check, $block);
  var l = function ($this$launch, $completion) {
    return i.f2y($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
function Signal$_init_$lambda_6vimhp() {
  return Unit_instance;
}
function invoke(_this__u8e3s4) {
  return _this__u8e3s4.r38(Unit_instance);
}
function *_generator_invoke__zhh2q8_1($this, value, $completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
    if ($this.m38_1.j1()) {
      break $l$block;
    }
    try {
      $this.o38_1 = $this.o38_1 + 1 | 0;
      // Inline function 'korlibs.io.async.fastIterateRemove' call
      var this_0 = $this.m38_1;
      var n = 0;
      var m = 0;
      while (n < this_0.g1()) {
        if (m >= 0 && !(m === n)) {
          this_0.i3(m, this_0.h1(n));
        }
        // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
        var node = this_0.h1(n);
        var remove = node.s38_1;
        // Inline function 'korlibs.io.async.AsyncSignal.invoke.<anonymous>' call
        var tmp = node.t38_1(value, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        if (remove) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.g1() > m) {
        this_0.j3(this_0.g1() - 1 | 0);
      }
    }finally {
      $this.o38_1 = $this.o38_1 - 1 | 0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$this.n38_1.j1()) {
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_1 = $this.n38_1;
        var n_0 = 0;
        var m_0 = 0;
        while (n_0 < this_1.g1()) {
          if (m_0 >= 0 && !(m_0 === n_0)) {
            this_1.i3(m_0, this_1.h1(n_0));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var it = this_1.h1(n_0);
          $this.m38_1.g3(it);
          if (true) {
            m_0 = m_0 - 1 | 0;
          }
          n_0 = n_0 + 1 | 0;
          m_0 = m_0 + 1 | 0;
        }
        while (this_1.g1() > m_0) {
          this_1.j3(this_1.g1() - 1 | 0);
        }
      }
    }
  }
  return Unit_instance;
}
function AsyncSignal$_init_$lambda_rsv6fb() {
  return Unit_instance;
}
function BaseSignal$_init_$lambda_tuu04y() {
  return Unit_instance;
}
function runBlockingNoSuspensions(callback) {
  var completed = {_v: false};
  var rresult = {_v: null};
  var resultEx = {_v: null};
  var suspendCount = {_v: 0};
  startCoroutineUndispatched(callback, new runBlockingNoSuspensions$1(suspendCount, resultEx, completed, rresult));
  if (!completed._v)
    throw IllegalStateException.h5('runBlockingNoSuspensions was not completed synchronously! suspendCount=' + suspendCount._v);
  if (!(resultEx._v == null))
    throw ensureNotNull(resultEx._v);
  var tmp;
  if (rresult._v == null) {
    throwUninitializedPropertyAccessException('rresult');
  } else {
    tmp = rresult._v;
  }
  return tmp;
}
function startCoroutineUndispatched(_this__u8e3s4, completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.startDirect' call
    var tmp;
    try {
      // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>' call
      // Inline function 'korlibs.io.async.withCoroutineContext' call
      completion.hd();
      // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
      tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(e));
        completion.jd(tmp$ret$4);
        break $l$block;
      } else {
        throw $p;
      }
    }
    var value = tmp;
    if (!(value === get_COROUTINE_SUSPENDED())) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
      var tmp$ret$7 = _Result___init__impl__xyqfz8(value_0);
      completion.jd(tmp$ret$7);
    }
  }
}
function _get_unitInstance__yoa8mq($this) {
  return Unit_instance;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function get_NativeThreadThread_isSupported() {
  _init_properties_NativeThread_js_kt__xin1zw();
  return NativeThreadThread_isSupported;
}
var NativeThreadThread_isSupported;
function get_warnSleep() {
  _init_properties_NativeThread_js_kt__xin1zw();
  // Inline function 'kotlin.getValue' call
  var this_0 = warnSleep$delegate;
  warnSleep$factory();
  return this_0.w1();
}
var warnSleep$delegate;
function NativeNativeThread_getId(thread) {
  _init_properties_NativeThread_js_kt__xin1zw();
  return new Long(0, 0);
}
function NativeThreadThread_current() {
  _init_properties_NativeThread_js_kt__xin1zw();
  return new Long(0, 0);
}
function NativeThreadThread_start(name, isDaemon, priority, code) {
  _init_properties_NativeThread_js_kt__xin1zw();
  throw NotImplementedError.je();
}
function NativeThreadThread_sleep(time) {
  _init_properties_NativeThread_js_kt__xin1zw();
  get_warnSleep();
  var start = Monotonic_instance.fk();
  // Inline function 'korlibs.concurrent.thread.NativeThreadThread_spinWhile' call
  $l$loop: while (true) {
    // Inline function 'korlibs.concurrent.thread.NativeThreadThread_sleep.<anonymous>' call
    if (!(compareTo_0(ValueTimeMark__elapsedNow_impl_eonqvs(start), time) < 0)) {
      break $l$loop;
    }
  }
}
function warnSleep$delegate$lambda() {
  _init_properties_NativeThread_js_kt__xin1zw();
  println('!!! Sync sleeping on JS');
  return Unit_instance;
}
function warnSleep$factory() {
  return getPropertyCallableRef('warnSleep', 0, KProperty0, function () {
    get_warnSleep();
    return Unit_instance;
  }, null);
}
var properties_initialized_NativeThread_js_kt_lgs6ti;
function _init_properties_NativeThread_js_kt__xin1zw() {
  if (!properties_initialized_NativeThread_js_kt_lgs6ti) {
    properties_initialized_NativeThread_js_kt_lgs6ti = true;
    NativeThreadThread_isSupported = false;
    warnSleep$delegate = lazy(warnSleep$delegate$lambda);
  }
}
//region block: post-declaration
initMetadataForClass(NonRecursiveLock, 'NonRecursiveLock', NonRecursiveLock);
initMetadataForInterface(BaseLockWithNotifyAndWait, 'BaseLockWithNotifyAndWait');
protoOf(LockImpl).g36 = notify$default;
initMetadataForClass(LockImpl, 'LockImpl', VOID, VOID, [BaseLockWithNotifyAndWait]);
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForClass(FixedPoolNativeThreadDispatcher, 'FixedPoolNativeThreadDispatcher', VOID, VOID, [CoroutineDispatcher, AutoCloseable, Delay], [1]);
initMetadataForClass(TimedTask, 'TimedTask', VOID, VOID, [Comparable, DisposableHandle]);
initMetadataForClass(NativeThreadDispatcher, 'NativeThreadDispatcher', NativeThreadDispatcher.n37, VOID, [CoroutineDispatcher, AutoCloseable, Delay], [1]);
initMetadataForLambda(onCancel$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(onCancel$slambda, VOID, VOID, [1]);
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_1);
protoOf(PreferSyncIo).ud = get;
protoOf(PreferSyncIo).do = fold;
protoOf(PreferSyncIo).co = minusKey;
protoOf(PreferSyncIo).eo = plus;
initMetadataForClass(PreferSyncIo, 'PreferSyncIo', VOID, VOID, [Element]);
initMetadataForClass(BaseSignal, 'BaseSignal', VOID, VOID, VOID, [0]);
initMetadataForClass(Signal, 'Signal', Signal, VOID, VOID, [0]);
initMetadataForClass(AsyncSignal, 'AsyncSignal', AsyncSignal, VOID, VOID, [1, 0]);
initMetadataForClass(Node, 'Node', VOID, VOID, [AutoCloseable]);
protoOf(runBlockingNoSuspensions$1$context$1).ud = get_0;
protoOf(runBlockingNoSuspensions$1$context$1).co = minusKey_0;
protoOf(runBlockingNoSuspensions$1$context$1).wd = releaseInterceptedContinuation;
protoOf(runBlockingNoSuspensions$1$context$1).c2m = invokeOnTimeout;
initMetadataForClass(runBlockingNoSuspensions$1$context$1, VOID, VOID, VOID, [AbstractCoroutineContextElement, ContinuationInterceptor, Delay], [1]);
initMetadataForClass(runBlockingNoSuspensions$1, VOID, VOID, VOID, [Continuation]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(Lock, 'Lock', Lock, VOID, [LockImpl, BaseLockWithNotifyAndWait]);
//endregion
//region block: init
Companion_instance_1 = new Companion_0();
Companion_instance_3 = new Companion_2();
//endregion
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstance3o77vcoredkpt,
  Companion_getInstance_2 as Companion_getInstancet6d3dkp9rzuf,
  Lock as Lock5n7hh3dgcidl,
  NonRecursiveLock as NonRecursiveLock2vf7fkhp857q,
  FixedPoolNativeThreadDispatcher as FixedPoolNativeThreadDispatcher1vd3m0y3p4oiv,
  AsyncSignal as AsyncSignal3p186s2w7f15b,
  Signal as Signal3nnez3346azzf,
  invoke as invoke2sf88d1xeuyqh,
  onCancel as onCancel134048q5p9j85,
  runBlockingNoSuspensions as runBlockingNoSuspensions25hsuevf2mle,
};
//endregion
